import axios from 'axios';

const API_BASE_URL = 'http://localhost:3001/api';

export interface NotificationRecord {
  id: string;
  channel: 'email' | 'sms' | 'inapp' | 'multi';
  subject: string;
  message: string;
  audience: any;
  template: string;
  status: 'queued' | 'sent' | 'failed';
  createdBy: string;
  createdAt: string;
}

export interface TemplateDef {
  key: string;
  label: string;
  subject: string;
  message: string;
}

class NotificationsService {
  async list(): Promise<NotificationRecord[]> {
    const res = await axios.get(`${API_BASE_URL}/notifications`);
    return res.data;
  }

  async templates(): Promise<TemplateDef[]> {
    const res = await axios.get(`${API_BASE_URL}/notifications/templates`);
    return res.data;
  }

  async create(payload: {
    channel: 'email' | 'sms' | 'inapp' | 'multi';
    subject?: string;
    message: string;
    audience?: any;
    template?: string;
    createdBy?: string;
    scheduledAt?: string | null;
  }): Promise<NotificationRecord> {
    const res = await axios.post(`${API_BASE_URL}/notifications`, payload);
    return res.data;
  }

  async preview(audience: any): Promise<{ estimatedRecipients: number }> {
    const res = await axios.post(`${API_BASE_URL}/notifications/preview`, { audience });
    return res.data;
  }
}

export default new NotificationsService();


